// removed by extract-text-webpack-plugin
module.exports = {"BurgerButton":"_1_G_9ByA","BurgerBar":"_2kbtQiaa","CrossButton":"_1W6NYG14","Cross":"_3h6nmoPA","Menu":"_2yZdb3Ec","MenuPanel":"Cv-IW03d","LogoContainer":"hXnaPzfX","LogoIcon":"_1vJGFgCc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/burger-menu/burger-menu-component.styles.scss
// module id = 562
// module chunks = 0